module.exports = __webpack_public_path__ + "ml.fb6915d21e4b27b617f6.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ml.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ml.svg
// module chunks = styles